import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogRef,
  NbIconModule,
  NbInputModule,
  NbToastrService
} from '@nebular/theme';
import { Subject, takeUntil } from 'rxjs';
import { CampaignWebSocketService } from 'src/app/core/services/web-socket.service';
import { CampaignService } from '../../services/campaign.service';

@Component({
  selector: 'app-campaign-terminate-modal',
  templateUrl: './campaign-terminate-modal.component.html',
  styleUrls: ['./campaign-terminate-modal.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, NbInputModule, FormsModule]
})
export class CampaignTerminateModalComponent implements OnDestroy {
  private unsubscribe = new Subject<void>();

  public reasonText = '';
  public campaign;

  constructor(
    protected ref: NbDialogRef<CampaignTerminateModalComponent>,
    private service: CampaignService,
    private socketService: CampaignWebSocketService,
    private toastrService: NbToastrService
  ) {}

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public terminate() {
    if (this.campaign.batch_job_id) {
      this.service
        .terminateCampaignJob(null, this.reasonText)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data.message === 'successful') {
            this.socketService.closeWindow(data.job_id);
            this.ref.close(true);
          } else {
            this.toastrService.show(
              status,
              $localize`Terminating Campaign: ${this.campaign.name}'s Job: ${this.campaign.batch_job_id} Failed`,
              {
                status: 'danger'
              }
            );
          }
        });
    } else {
      this.toastrService.show(status, $localize`Could not find Job ID, try refreshing the Campaigns Table.`, {
        status: 'danger'
      });
    }
  }

  public close() {
    this.ref.close(false);
  }
}
